<template>
  <div class="log-box">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:getData})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="tableData" max-height="550" border>
        <el-table-column
          show-overflow-tooltip
          v-for="item in $public.info"
          :key="item.key"
          :prop="item.key"
          align="center"
          :label="item.value">
        </el-table-column>
        <el-table-column label="详情" type="expand">
          <template slot-scope="props">
            <div v-if="props.row.fileIds === ''?false:true">
              <span   v-for="(item,index) in props.row.fileIds"
                  :key="index"
                  style="margin-left:10px"
                  >
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="item"
                  :preview-src-list="props.row.fileIds">
                </el-image>
              </span>
            </div>
            <div v-else>
              <span>无详情图片</span>
            </div>
            <div class="content">
              <h3>服务内容：</h3>
              <p>{{props.row.serviceContent}}</p>
            </div>
            <div class="content">
              <h3>服务结果：</h3>
              <p>{{props.row.serviceResult}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging
        :pagesData="$data.paging_data"
        @set_page_number = 'get_page_number'
    ></paging>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/helpLog',
      tableData:[],
      form:{
        operateLogType:3
      },
    }
  },
  created() {
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    getData(data) {
      this.tableData = data
      this.tableData.forEach(element => {
        element.operateLogType = this.$public.type[element.operateLogType - 1]
        if (element.fileIds === '') {} else {
          element.fileIds = element.fileIds.split(",")
          element.fileIds.forEach((item,index) => {
            element.fileIds[index] = this.$api.imgUrl+ '/user/img/' +item
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.content{
  width: 100%;
  word-wrap: break-word; 
  word-break: normal;
}
</style>